// extracted by mini-css-extract-plugin
module.exports = {"scrollSection":"scroll-section_scrollSection__KBJZI","scrollContainer":"scroll-section_scrollContainer__9CIKD"};